import { render, staticRenderFns } from "./os_skd.vue?vue&type=template&id=e0213ba2&scoped=true&"
import script from "./os_skd.vue?vue&type=script&lang=js&"
export * from "./os_skd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0213ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0213ba2')) {
      api.createRecord('e0213ba2', component.options)
    } else {
      api.reload('e0213ba2', component.options)
    }
    module.hot.accept("./os_skd.vue?vue&type=template&id=e0213ba2&scoped=true&", function () {
      api.rerender('e0213ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/uprox_status/os/os_skd.vue"
export default component.exports